export default function initialState() {
  return {
    form: {
      id: null,
      date: new Date(),
      hours: 0,
      dials: 0,
      contacts: 0,
      listing_nurtures: 0,
      listings_set: 0,
      listings_held: 0,
      listings_taken: 0,
      listings_sold: 0,
      buyer_nurtures: 0,
      buyers_set: 0,
      buyers_held: 0,
      buyers_signed: 0,
      buyers_sold: 0,
      price_correction: 0,
      offers_written: 0,
      tracking_sources: []
    },
    errorList: null,
  }
};